import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';
import { CONSTS } from './const';
import { AxiosResponseModel } from '../../@types/base';
import {
  SupervisorData
} from '../../@types/supervisor';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';

// ----------------------------------------------------------------------

type SupervisorState = {
  supervisorError: boolean;
  isSupervisorLoading: boolean;
  supervisor: SupervisorData | null;
  updateCompanySupervisorIsOpen: boolean;
};

const initialState: SupervisorState = {
  supervisorError: false,
  isSupervisorLoading: false,
  supervisor: null,
  updateCompanySupervisorIsOpen: false
};

const slice = createSlice({
  name: 'supervisor',
  initialState,
  reducers: {

    startSupervisorLoading(state) {
      state.isSupervisorLoading = true;
    },

    stopSupervisorLoading(state) {
      state.isSupervisorLoading = false;
      state.supervisorError = false;
    },

    hasErrorSupervisor(state) {
      state.isSupervisorLoading = false;
      state.supervisorError = true;
    },

    setSupervisor(state, action) {
      state.supervisor = action.payload;
    }

  }
});

// Reducer
export default slice.reducer;

export const {
  setSupervisor
} = slice.actions;

export async function getSupervisor() {
  dispatch(slice.actions.startSupervisorLoading());
  try {
    const response: AxiosResponseModel<SupervisorData> = await axios
      .get(`${CONSTS.SUPERVISOR_GET_SUPERVISOR}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorSupervisor(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopSupervisorLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorSupervisor());
    }
    dispatch(slice.actions.setSupervisor(response.data?.data || null));
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorSupervisor(error));
  }
  return null;
}